import { useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { hysteriFetch, wrappers } from 'hysterics';
import { setNewRelicCustomAttribute } from '@ddc/new-relic';
import logger from 'ws-scripts/modules/logger';

const fetchWindowStickerUrl = hysteriFetch(
	'ws-quick-specs/getwindowstickerurl'
);

const useWindowSticker = () => {
	const { vehicle } = useSelector((state) => state);
	const [windowStickerUrl, setWindowStickerUrl] = useState('');
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		setIsLoading(true);
		setWindowStickerUrl('');

		const getWindowStickerUrl = async () => {
			try {
				const response = await fetchWindowStickerUrl(
					'/api/widget/ws-quick-specs/getwindowstickerurl',
					{
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify(vehicle)
					},
					{
						[wrappers.retry.contextKey]: {
							retries:
								vehicle.flags[
									'ws-vehicle-ctas-window-sticker-retries'
								]
						},
						[wrappers.timeout.contextKey]: {
							timeout:
								vehicle.flags[
									'ws-vehicle-ctas-window-sticker-timeout'
								]
						}
					}
				);
				// response.data will be either a window sticker URL or the boolean `false`
				const url = response.data;
				if (url) {
					setWindowStickerUrl(url);
				}
			} catch (e) {
				const customAttribute =
					'WS QUICK SPECS/WINDOW STICKER HEAD REQUEST ERROR';
				setNewRelicCustomAttribute(customAttribute, `${e}`);
				logger.error(`${customAttribute}: ${e}`);
			} finally {
				setIsLoading(false);
			}
		};

		getWindowStickerUrl();
	}, [vehicle]);

	return {
		windowStickerUrl,
		isLoading
	};
};

export default useWindowSticker;
